import { useMutation, useQueryClient } from '@tanstack/react-query';

import { indirectTaxContentIngestionKeys } from './keys';
import { refreshContentIngestion } from './refreshContentIngestion';

export function useRefreshContentIngestion() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: refreshContentIngestion,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: indirectTaxContentIngestionKeys.all,
      });
    },
  });
}
